import { createVuetify, type VuetifyOptions } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { en, es } from 'vuetify/locale';

const vuetifyTheme = {
  dark: false,
  colors: {
    primary: '#2340B7',
  },
};

// Single Vuetify configuration shared by the application and audit
// entrypoints (and the spec helper), so breakpoint settings and component
// defaults can never drift between surfaces.
export function createKuidoVuetify(overrides: VuetifyOptions = {}) {
  return createVuetify({
    components,
    directives,
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
    theme: {
      defaultTheme: 'vuetifyTheme',
      themes: { vuetifyTheme },
      cspNonce: document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') || undefined,
    },
    locale: {
      locale: 'es',
      fallback: 'en',
      messages: { es, en },
    },
    // components that take a mobile-breakpoint prop (and useDisplay().mobile)
    // treat anything below md (960px) as mobile
    display: {
      mobileBreakpoint: 'md',
    },
    defaults: {
      // Clear the typed search text after each selection. Without this,
      // Vuetify keeps the filter string on multiple-select autocompletes, so
      // the list stays filtered and selecting feels sluggish/buggy.
      VAutocomplete: {
        clearOnSelect: true,
      },
    },
    ...overrides,
  });
}
